import PaginationRequestModel from "../viewModels/request/PaginationRequestModel";

export interface LoanVM {
  Amount: number;
  Installment: number;
  ProposedPaymentDate: Date;
  Description: string;
  TeamMemberId: string;
  TeamMemberName: string;
  id: string;
  Status: LoanStatus;
}

export interface LoanItem {
  Amount: number;
  IsDeleted: boolean;
  LoanTotalAmount: number;
  LoanTotalPaidAmount: number;
  LoanTotalUnPaidAmount: number;
  LoanLastPaidInstallmentAmount: number;
  PayRunId: string;
  PaidDate: Date;
  Description: string;
  LoanId: string;
}

export interface LoanRequest {
  TeamMemberId: string;
  status: number | null;
  paginationModel: PaginationRequestModel;
}

export interface LoanApprovalModel {
  LoanId: string;
  PaymentReference: string;
  RejectionReason: string;
  StartPaymentDate: Date;
  IsRejected: boolean;
}

export interface UnpaidLoanItemRequestModel {
  TeamMemberId: string;
  StartDate: Date;
  EndDate: Date;
}

export enum LoanStatus {
  Pending,
  Approved,
  Rejected,
  FullyPaid,
}
